import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Net ROI by Project',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Net ROI by Project',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Net ROI',
                          color: '#22C55E',
                          points: {
                            '@': 'projectRoiPoints',
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Project',
                  yLabel: 'Net ROI (USD)',
                  description:
                    'Projects ranked by total net ROI generated from Cursor events.',
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    projectRoiPoints: {
      sort: {
        by: {
          '+': {
            '@': 'eventNetRoiValues',
          },
        },
        descending: true,
      },
      filter: {
        and: [
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'projectId',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': '!id',
                  },
                  {
                    '@>': [
                      {
                        '@$': 'projectId',
                      },
                      'ent:!projects:!proj',
                    ],
                  },
                ],
              },
            ],
          },
          {
            '>': [
              {
                '#': {
                  '@': 'eventNetRoiValues',
                },
              },
              0,
            ],
          },
        ],
      },
      target: 'ent:!projects:!proj',
      quantity: 10,
      selection: {
        '{}': {
          x: {
            '@.': '!name',
          },
          y: {
            '+': {
              '@': 'eventNetRoiValues',
            },
          },
          name: {
            '@.': '!name',
          },
        },
      },
      subqueries: {
        eventNetRoiValues: {
          ref: {
            attr: 'attr:ent#!cursor_usage_events#!cursor_usage_event:!project',
            inherit: '-',
          },
          target: 'ent:!cursor_usage_events:!cursor_usage_event',
          selection: {
            '@.': '!net_roi_usd',
          },
        },
      },
    },
  },
}
